import { atomWithStorage } from 'jotai/utils';

export const cachedDealerListAtom = atomWithStorage<number[]>('cached-dealer-list', []);
